import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllAutomations(_obj, params) {
    const res = await axios.get('api/automations/', { params });
    return res.data;
  },
  async getAutomation(_obj, id) {
    const res = await axios.get(`api/automations/${id}/`);
    return res.data;
  },
  async createAutomation(_obj, data) {
    return axios.post('api/automations/', data);
  },
  async updateAutomation(_obj, { id, data }) {
    return axios.patch(`api/automations/${id}/`, data);
  },
  async deleteAutomation(_obj, id) {
    return axios.delete(`api/automations/${id}/`);
  },
  async toggleAutomation(_obj, id) {
    return axios.post(`api/automations/${id}/toggle/`);
  },
  async getAutomationLogs(_obj, id) {
    const res = await axios.get(`api/automations/${id}/logs/`);
    return res.data;
  },
  async getAllAutomationLogs(_obj, params) {
    const res = await axios.get('api/automations/logs/', { params });
    return res.data;
  },
};

export const automation = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
